module.exports = __webpack_public_path__ + "static/media/scale_0.d9393b2d.svg";